"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var responsive_1 = require("@dynamynd/responsive");

var styled_components_1 = __importDefault(require("styled-components"));

exports.StrengthsTitle = styled_components_1.default(components_lib_1.Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);
  return "\n            max-width: " + (smallOrMedium ? 100 : 80) + "%;\n            text-align: " + (smallOrMedium ? 'center' : 'left') + ";\n        ";
});
exports.default = responsive_1.withResponsiveMeta(exports.StrengthsTitle);
var templateObject_1;